import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import { SwipeableDrawer, Drawer } from "@material-ui/core";
import DeliveryTimeChange from "./DeliveryTimeChange";
import moment from "moment";
import { ReactComponent as DeliveryBike } from "../assets/delivery.svg";
import { ReactComponent as PickupIcon } from "../assets/pickup.svg";
import { ReactComponent as Plane } from "../assets/travelling.svg";
import { setDrawer } from "../../../store/actions/deliveryTime";

class DeliveryTime extends Component {
  getArabicMonths = (string) => {
    const ar_months = {
      Jan: "يناير",
      Feb: "فبراير",
      Mar: "مارس",
      Apr: "ابريل",
      May: "مايو",
      Jun: "يونيو",
      Jul: "يوليو",
      Aug: "اغسطس",
      Sep: "سبتمبر",
      Oct: "اكتوبر",
      Nov: "نوفمبر",
      Dec: "ديسمبر",
    };
    let tempString;
    for (let i = 0; i < Object.keys(ar_months).length; i++) {
      tempString = string.replace(
        Object.keys(ar_months)[i],
        ar_months[Object.keys(ar_months)[i]],
      );
      if (tempString != string) break;
    }
    return tempString;
  };

  asapText = (within, isPickup) => {
    const { language, settings, has_preordering } = this.props;
    if (
      settings.enable_on_demand_custom_string &&
      !isPickup &&
      !has_preordering
    )
      return language === "arabic"
        ? settings.on_demand_custom_string_ar
        : settings.on_demand_custom_string;
    else if (
      settings.enable_on_demand_custom_string_pickup &&
      isPickup &&
      !has_preordering
    )
      return language === "arabic"
        ? settings.on_demand_pickup_custom_string_ar
        : settings.on_demand_pickup_custom_string;
    if (within >= 1440) {
      const days = Math.floor(within / 1440);
      const hours = Math.floor((within - days * 1440) / 60);
      if (language == "english")
        return `${isPickup ? "Pickup" : "Deliver"} in about ${days} day${
          days > 1 ? "s" : ""
        }${hours > 0 ? ` and ${hours} hours` : ""}`;
      else return `خلال ${days} يوم ${hours > 0 ? `و ${hours} ساعة` : ""}`;
    } else if (within < 1440 && within > 0) {
      const hours = Math.floor(within / 60);
      const minutes = Math.floor(within - hours * 60);

      if (language == "english") {
        let temp = isPickup ? "Pickup in about " : "Deliver in about ";

        if (hours) temp = temp.concat(`${hours} hour${hours > 1 ? "s" : ""}`);
        if (minutes)
          temp = temp.concat(
            `${hours > 0 ? " and " : ""}${minutes} minute${
              minutes > 1 ? "s" : ""
            }`,
          );
        return temp;
      } else {
        let temp = "خلال ";
        if (hours) temp = temp.concat(`${hours} ساعة`);
        if (minutes)
          temp = temp.concat(`${hours > 0 ? " و " : ""}${minutes} دقيقة`);
        return temp;
      }
    } else {
      if (language == "english")
        return `${isPickup ? "Pickup" : "Deliver"} in about ${within} minutes`;
      else return `${isPickup ? "استلام" : "توصيل"} خلال ${within} دقيقة`;
    }
  };

  translateDate = (str) => {
    const ar_months = {
      Jan: "يناير",
      Feb: "فبراير",
      Mar: "مارس",
      Apr: "ابريل",
      May: "مايو",
      Jun: "يونيو",
      Jul: "يوليو",
      Aug: "اغسطس",
      Sep: "سبتمبر",
      Oct: "اكتوبر",
      Nov: "نوفمبر",
      Dec: "ديسمبر",
    };

    const ar_days = {
      Sun: "الأحد",
      Mon: "الاثنين",
      Tue: "الثلاثاء",
      Wed: "الاربعاء",
      Thu: "الخميس",
      Fri: "الجمعة",
      Sat: "السبت",
      Today: "اليوم",
      Tomorrow: "غدا",
    };

    let temp = str;
    temp = temp.replace("On", "يوم");
    temp = temp.replace(/AM/g, "ص");
    temp = temp.replace(/PM/g, "م");

    Object.keys(ar_months).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_months[key]);
    });
    Object.keys(ar_days).forEach((key) => {
      if (temp.includes(key)) temp = temp.replace(key, ar_days[key]);
    });

    return temp;
  };
  nonAsapText = () => {
    const { expected_start, expected_date, expected_end, today_date } =
      this.props.deliveryTime;
    const { language, customTexts, settings } = this.props;
    const format = settings.military_delivery_time ? "HH:mm" : "h:mm A";
    let date;
    if (expected_date != moment().format("YYYY-MM-DD")) {
      if (
        moment().add(1, "days").format("YYYY-MM-DD") ===
        moment(expected_date, "YYYY-MM-DD").format("YYYY-MM-DD")
      ) {
        date = "Tomorrow";
      } else if (moment(expected_date, "YYYY-MM-DD").year() > moment().year()) {
        date = moment(expected_date, "YYYY-MM-DD").format("ddd MMM DD Y");
      } else {
        date = moment(expected_date, "YYYY-MM-DD").format("ddd MMM DD");
      }
    } else date = "Today";
    let start = moment(expected_start, "HH:mm").format(format);
    let end = moment(expected_end, "HH:mm").format(format);
    let finalDateString;
    if (start == end) {
      finalDateString = `${date} - ${start}`;
    } else {
      finalDateString = `${date} - ${start} ${
        this.props.language === "english" ? "to" : "إلى"
      } ${end}`;
    }

    if (language == "english") return finalDateString;
    else return this.translateDate(finalDateString);
  };

  render() {
    const { language, deliveryTime, settings, customTexts } = this.props;

    const textRenderDelivery = () => {
      if (
        deliveryTime.type == "asap" &&
        deliveryTime.asap &&
        deliveryTime.asap.now
      ) {
        if (deliveryTime.asap.is_international) {
          if (language == "english")
            return `International shipping within ${parseInt(
              deliveryTime.asap.within / 1440,
            )} days`;
          else
            return `شحن دولي خلال ${parseInt(
              deliveryTime.asap.within / 1440,
            )} يوم`;
        } else
          return this.asapText(deliveryTime.asap.within, deliveryTime.isPickup);
      }

      return this.nonAsapText();
    };

    const showEditIcon =
      (deliveryTime.scheduled && !deliveryTime.isPickup) ||
      (deliveryTime.pickup &&
        deliveryTime.isPickup &&
        !deliveryTime.asap?.is_international);

    return (
      <>
        <Drawer
          anchor="bottom"
          classes={{
            paperAnchorBottom: language == "arabic" ? "left-auto" : "",
          }}
          open={deliveryTime.drawerOpen}
          onClose={() => this.props.setDrawer(false)}
          PaperProps={{
            style: { minHeight: 100, height: "auto", width: "100%" },
            className: "text-center",
          }}
          onBackdropClick={() => this.props.setDrawer(false)}
        >
          <DeliveryTimeChange
            fromActionButton={this.props.fromActionButton}
            handleDialogContinue={this.props.handleDialogContinue}
            applyMarginTopToCloseButton={!showEditIcon}
            text={textRenderDelivery()}
          />
        </Drawer>
        <div style={{ marginTop: 30 }}>
          <p
            className="box-title"
            style={{ textAlign: language === "arabic" ? "right" : "left" }}
          >
            {language == "english"
              ? !deliveryTime.isPickup
                ? customTexts.delivery_time
                : customTexts.pickup_time
              : !deliveryTime.isPickup
                ? customTexts.delivery_time_ar
                : customTexts.pickup_time_ar}
          </p>
          <div
            className="border-top border-bottom row w-100 mx-0 justify-content-between bold"
            style={{ backgroundColor: "white", height: 60 }}
            dir={language == "english" ? "ltr" : "rtl"}
            onClick={() => {
              showEditIcon && this.props.setDrawer(true);
              this.props.setActionButtonFalse();
            }}
          >
            <div
              className={"col-9 align-self-center ml-0 ".concat(
                language == "english" ? "text-left" : "text-right",
              )}
              style={{
                fontSize: "1rem",
                //fontWeight: 400,
                color:
                  deliveryTime.expected_date != moment().format("YYYY-MM-DD") &&
                  "red",
              }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "50px auto",
                  alignItems: "center",
                }}
              >
                {!deliveryTime.isPickup ? (
                  deliveryTime.asap?.is_international ? (
                    <Plane style={{ width: 25, height: 25 }} />
                  ) : (
                    <DeliveryBike style={{ width: 30, height: 30 }} />
                  )
                ) : (
                  <PickupIcon style={{ width: 30, height: 30 }} />
                )}
                <div style={{ whiteSpace: "nowrap" }}>
                  {textRenderDelivery()}
                </div>
              </div>
            </div>
            {showEditIcon ? (
              <div
                className={"col-2 align-self-center mr-4 pr-0 ".concat(
                  language == "english" ? "text-right" : "text-left",
                )}
              >
                <EditIcon style={{ color: "#5b5b5b" }} />
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    deliveryTime: state.deliveryTime,
    settings: state.store.store.settings,
    customTexts: state.store.store.settings.custom_texts,
    has_preordering:
      state.cart.preordering_max_leadtime > 0 &&
      state.cart.preordered_items > 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDrawer: (state) => dispatch(setDrawer(state)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTime);
